export interface ChangeEntry {
  name: string;
  changes: {
    old?: any;
    new: any;
  };
}

export interface ElectronicDocumentStatusHistory {
  id?: number;
  invoiceId?: number | null;
  creditNoteId?: number | null;
  debitNoteId?: number | null;
  remissionNoteId?: number | null;
  autoInvoiceId?: number | null;
  receiptId?: number | null;
  documentType?: string;
  status?: string;
  cdc?: string | null;
  setResponseCode?: string | null;
  setResponseDescription?: string | null;
  setError?: string | null;
  changes?: ChangeEntry[] | null;
  /** Null when nobody produced it: the SET polling, imports, older rows. */
  actorUserId?: number | null;
  actorOrigin?: string | null;
  actorCredentialId?: number | null;
  actor?: {
    id: number;
    email: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
  createdAt?: string;
  updatedAt?: string;
}

/** Where a transition came from, in the words of the history screen. */
export const ACTOR_ORIGIN_CHOICES: Map<string, string> = new Map([
  ["panel", "Panel"],
  ["api_v2", "API"],
  ["user_api_key", "API con clave de usuario"],
  ["ai", "Asistente de IA"],
]);

/**
 * Who produced a transition: the person and where they did it from.
 *
 * The public API authenticates a company rather than a person, so those rows
 * name only the origin. A row with neither was written by SmartDoc itself.
 */
export const describeActor = (
  record: ElectronicDocumentStatusHistory,
): string => {
  const origin =
    record.actorOrigin !== undefined && record.actorOrigin !== null
      ? (ACTOR_ORIGIN_CHOICES.get(record.actorOrigin) ?? record.actorOrigin)
      : null;

  const name = record.actor
    ? `${record.actor.firstName ?? ""} ${record.actor.lastName ?? ""}`.trim() ||
      record.actor.email
    : null;

  if (name === null && origin === null) {
    return "Sistema";
  }

  return [name, origin].filter((part) => part !== null).join(" · ");
};

export const newElectronicDocumentStatusHistory =
  (): ElectronicDocumentStatusHistory => {
    return {};
  };
